import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './hardwarerestoration.css'; // Import the CSS file for styling

const HardwareRestoration = () => {
  // State to track the current image index
  const [currentIndex, setCurrentIndex] = useState(0);

  // Array of images
  const images = [
 "/images/Hardware Restoration/Hardware_01.jpg",
"/images/Hardware Restoration/Hardware_02.jpg",
"/images/Hardware Restoration/Hardware_03.jpg",
"/images/Hardware Restoration/Hardware_04.jpg",
"/images/Hardware Restoration/Hardware_05.jpg",
"/images/Hardware Restoration/Hardware_06.jpg",
"/images/Hardware Restoration/Hardware_07.jpg",
"/images/Hardware Restoration/Hardware_08.jpg",
"/images/Hardware Restoration/Hardware_09.jpg",
"/images/Hardware Restoration/Hardware_10.jpg",
"/images/Hardware Restoration/Hardware_11.jpg",
"/images/Hardware Restoration/Hardware_12.jpg",
"/images/Hardware Restoration/Hardware_13.jpg",
"/images/Hardware Restoration/Hardware_14.jpg",
"/images/Hardware Restoration/Hardware_15.jpg",
"/images/Hardware Restoration/Hardware_16.jpg",
"/images/Hardware Restoration/Hardware_17.jpg",
"/images/Hardware Restoration/Hardware_18.jpg",
"/images/Hardware Restoration/Hardware_19.jpg",
"/images/Hardware Restoration/Hardware_20.jpg"

  ];

  // Function to go to the next image
  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length); // Loop back to the first image
  };

  // Function to go to the previous image
  const prevImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length); // Loop to the last image
  };

  // Auto change image every 6 seconds
  useEffect(() => {
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval); // Clean up the interval when the component unmounts
  }, []);

  return (
    <div className="hardwarerestoration-container">
      <Link to="/" className="home-button">Home</Link> {/* Home button */}
      
      <div className="text-container">
        <h3 className="title-gc">Hardware & Restoration</h3>
        <p className="text-blurb">
          Traditional Line’s artisans have a long history of repair and restoration of antique door and
          cabinet hardware, including custom keying of antique mortise locks.
        </p>
      </div>

      <div className="image-frame">
        {/* Slideshow container */}
        <div className="slideshow-container">
          <img
            src={images[currentIndex]}
            alt={`Slide ${currentIndex}`}
            className="hardwarerestoration-image"
          />
          
          <button className="prev-button" onClick={prevImage}>❮</button>
          <button className="next-button" onClick={nextImage}>❯</button>
        </div>
      </div>
    </div>
  );
};

export default HardwareRestoration;
